/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * AcceptTermsRequest
 * Request model for accepting terms and privacy policy.
 */
export interface AcceptTermsRequest {
  /**
   * Accept Terms
   * @default true
   */
  accept_terms?: boolean;
  /**
   * Accept Privacy
   * @default true
   */
  accept_privacy?: boolean;
}

/**
 * ActionGetResponse
 * Response model for GET action endpoint.
 */
export interface ActionGetResponse {
  /** Action Id */
  action_id: string;
  /** Habit Id */
  habit_id: string;
  /** Question Type */
  question_type: string;
  /** Content */
  content: object;
}

/**
 * ActionResponseRequest
 * Request model for submitting action response.
 */
export interface ActionResponseRequest {
  /** Action Id */
  action_id: string;
  /**
   * Selected Options
   * @default []
   */
  selected_options?: number[];
  /** Follow Up Answer */
  follow_up_answer?: string | null;
  /** Quiz Answers */
  quiz_answers?: QuizAnswer[] | null;
}

/**
 * ActionResponseResult
 * Response model for action submission.
 */
export interface ActionResponseResult {
  /** Action Response Id */
  action_response_id: string;
  /** Habit Log Id */
  habit_log_id: string;
  /** Is Correct */
  is_correct?: boolean | null;
  /** Score */
  score?: number | null;
  /** Feedback */
  feedback?: string | null;
  /** Follow Up Question */
  follow_up_question?: object | null;
  /** Score Feedback */
  score_feedback?: string | null;
}

/**
 * ActionTypePickerItem
 * Single action type for the picker screen.
 */
export interface ActionTypePickerItem {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Action Type Enum */
  action_type_enum?: string | null;
  /** Description */
  description?: string | null;
  /** Response Count */
  response_count: number;
}

/**
 * ActionTypePickerResponse
 * Response for action type picker endpoint.
 */
export interface ActionTypePickerResponse {
  /** Action Types */
  action_types: ActionTypePickerItem[];
  /** Max Types Shown */
  max_types_shown: number;
}

/** ActivityOverTimeResponse */
export interface ActivityOverTimeResponse {
  /** Weeks */
  weeks: WeekPoint[];
  /** All Time Average */
  all_time_average: number;
}

/**
 * ActualResponse
 * Weekly actual value response.
 */
export interface ActualResponse {
  /** Week Number */
  week_number: number;
  /** Actual Value */
  actual_value: number;
  /**
   * Recorded At
   * @format date-time
   */
  recorded_at: string;
}

/**
 * AllObjectivesProgressResponse
 * Progress for all objectives using BDD rules.
 */
export interface AllObjectivesProgressResponse {
  /** Objectives */
  objectives: ObjectiveProgressResponse[];
}

/**
 * AppRoleResponse
 * App role with permission flags for frontend.
 */
export interface AppRoleResponse {
  /** Type */
  type: string;
  /** Is Standard */
  is_standard: boolean;
  /** Is Team Leader */
  is_team_leader: boolean;
  /** Is Leader */
  is_leader: boolean;
  /** Is Sponsor */
  is_sponsor: boolean;
  /** Is Admin */
  is_admin: boolean;
  /** Can Manage Teams */
  can_manage_teams: boolean;
  /** Can View Org Insights */
  can_view_org_insights: boolean;
}

/** BadgeCopyResponse */
export interface BadgeCopyResponse {
  /** Not Collected */
  not_collected: string;
  /** Collected */
  collected: string;
  /** Congrats Title */
  congrats_title: string;
  /** Congrats Body */
  congrats_body: string;
}

/** BadgeResponse */
export interface BadgeResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Category */
  category: string;
  /** Status */
  status: string;
  /** Counter */
  counter: number;
  /** Progress */
  progress?: object | null;
  copy?: BadgeCopyResponse;
}

/** BadgesResponse */
export interface BadgesResponse {
  /** Badges */
  badges: BadgeResponse[];
  /** Collected Count */
  collected_count: number;
  /** Total Count */
  total_count: number;
  /** Up Next */
  up_next: UpNextItem[];
}

/** BehaviourDetail */
export interface BehaviourDetail {
  /** Name */
  name: string;
  /** Engagement Status */
  engagement_status: string;
  /** Engagement Label */
  engagement_label: string;
  /** Avg Logs Per Week */
  avg_logs_per_week: number;
  /** Habits */
  habits: HabitDetail[];
}

/** BehaviourKPIInfo */
export interface BehaviourKPIInfo {
  /** Title */
  title: string;
  /** Improvement Percent */
  improvement_percent: number;
}

/**
 * BehaviourResponse
 * Response model for behaviour data.
 */
export interface BehaviourResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Sequence Order */
  sequence_order: number;
  /** Is Active */
  is_active: boolean;
  /**
   * Habits Count
   * @default 0
   */
  habits_count?: number;
}

/**
 * BehaviourWithHabitsResponse
 * Response model for behaviour with its habits.
 */
export interface BehaviourWithHabitsResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Sequence Order */
  sequence_order: number;
  /**
   * Habits
   * @default []
   */
  habits?: HabitrackApiV1ProgrammesHabitResponse[];
}

/** Body_upload_avatar_api_v1_auth_avatar_post */
export interface BodyUploadAvatarApiV1AuthAvatarPost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/**
 * ChatRequest
 * Request model for chat interaction.
 */
export interface ChatRequest {
  /** Message */
  message: string;
  /** Conversation History */
  conversation_history?: Record<string, string>[] | null;
  /**
   * Include Dashboard
   * @default true
   */
  include_dashboard?: boolean;
}

/**
 * ChatResponse
 * Response model for chat interaction.
 */
export interface ChatResponse {
  /** Response */
  response: string;
  /** Conversation Id */
  conversation_id?: string | null;
}

/**
 * CheckDomainRequest
 * Request model for domain check.
 */
export interface CheckDomainRequest {
  /**
   * Email
   * @format email
   */
  email: string;
}

/**
 * CheckDomainResponse
 * Response model for domain check.
 */
export interface CheckDomainResponse {
  /** Idp Type */
  idp_type: string;
  /** Tenant Id */
  tenant_id?: string | null;
  /** Client Id */
  client_id?: string | null;
  /** Organization Id */
  organization_id?: string | null;
}

/**
 * CohortMemberProgressResponse
 * Cohort member progress response.
 */
export interface CohortMemberProgressResponse {
  /** User summary for social features. */
  user: UserSummaryResponse;
  /** Active Habits */
  active_habits: object[];
  /** Total Progress Percentage */
  total_progress_percentage: number;
  /** Current Streak */
  current_streak: number;
  /** Total Endorsements */
  total_endorsements: number;
  /** Can View Details */
  can_view_details: boolean;
}

/** CohortOverviewHeader */
export interface CohortOverviewHeader {
  /** Active Cohorts */
  active_cohorts: number;
  /** Total Users */
  total_users: number;
  /** Avg Completion */
  avg_completion: number;
  /** Active Users Pct */
  active_users_pct: number;
  /** Engagement Status */
  engagement_status: string;
}

/** CohortRow */
export interface CohortRow {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Size */
  size: number;
  /** Start Date */
  start_date: string | null;
  /** End Date */
  end_date: string | null;
  /** Current Module */
  current_module: number | null;
  /** Active Users Pct */
  active_users_pct: number;
  /** Completion Rate */
  completion_rate: number;
}

/** CohortsOverview */
export interface CohortsOverview {
  header: CohortOverviewHeader;
  /** Cohorts */
  cohorts: CohortRow[];
  /** Total Count */
  total_count: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
}

/**
 * CommentResponse
 * Comment response model.
 */
export interface CommentResponse {
  /** Id */
  id: string;
  /** User summary for social features. */
  commenter: UserSummaryResponse;
  /** Comment Text */
  comment_text: string;
  /** Habit Log Date */
  habit_log_date?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/**
 * CreateCommentRequest
 * Request model for creating a comment.
 */
export interface CreateCommentRequest {
  /** Habit Log Id */
  habit_log_id: string;
  /** Content */
  content: string;
}

/**
 * CreateCustomHabitRequest
 * Request model for creating a custom habit.
 */
export interface CreateCustomHabitRequest {
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Instructions */
  instructions?: string | null;
  /** Estimated Time Minutes */
  estimated_time_minutes?: number | null;
  /**
   * Duration Days
   * @default 60
   */
  duration_days?: number;
  /**
   * Requires Note
   * @default false
   */
  requires_note?: boolean;
  /** Tips */
  tips?: string | null;
}

/**
 * CreateEndorsementRequest
 * Request model for creating an endorsement.
 */
export interface CreateEndorsementRequest {
  /** Endorsed User Id */
  endorsed_user_id: string;
  /** Habit Id */
  habit_id: string;
  /** Endorsement Option */
  endorsement_option: string;
}

/**
 * DashboardResponse
 * Main dashboard response.
 */
export interface DashboardResponse {
  /** User Name */
  user_name: string;
  /** Active Habits */
  active_habits: HabitCardResponse[];
  /** Progress chart data for dashboard. */
  progress_chart: ProgressChartData;
  /** Team widget data for dashboard. */
  team_widget: TeamWidgetResponse;
  /** Mood widget data for dashboard. */
  mood_widget: MoodWidgetResponse;
  /** Notifications */
  notifications: HabitrackApiV1DashboardNotificationResponse[];
  /** Quick Stats */
  quick_stats: object;
  /** Can Add More Habits */
  can_add_more_habits: boolean;
  /** Positive changes widget response. */
  positive_changes_widget: PositiveChangesWidgetResponse;
}

/**
 * DepartmentScope
 * Department scope for team leaders.
 */
export interface DepartmentScope {
  /** Department Id */
  department_id?: string | null;
  /** Department */
  department?: string | null;
  /** Sub Department Id */
  sub_department_id?: string | null;
  /** Sub Department */
  sub_department?: string | null;
  /** Team Id */
  team_id?: string | null;
  /** Team */
  team?: string | null;
}

/** DistributionBucket */
export interface DistributionBucket {
  /** Bucket */
  bucket: string;
  /** Percentage */
  percentage: number;
}

/** EndorsementDirection */
export type EndorsementDirection = 'given' | 'received';

/** EndorsementItemResponse */
export interface EndorsementItemResponse {
  /** Id */
  id: string;
  person: EndorsementPersonResponse;
  /** Habit Name */
  habit_name: string;
  /** Endorsement Option Label */
  endorsement_option_label: string;
  /** Endorsed At */
  endorsed_at: string;
}

/** EndorsementPersonResponse */
export interface EndorsementPersonResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Role */
  role: string | null;
  /** Avatar Url */
  avatar_url: string | null;
}

/**
 * EndorsementResponse
 * Endorsement response model.
 */
export interface EndorsementResponse {
  /** Id */
  id: string;
  /** User summary for social features. */
  endorser: UserSummaryResponse;
  /** User summary for social features. */
  endorsed_user: UserSummaryResponse;
  /** Habit Log Date */
  habit_log_date?: string | null;
  /** Message */
  message?: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** EndorsementsResponse */
export interface EndorsementsResponse {
  /** Total Count */
  total_count: number;
  /** Items */
  items: EndorsementItemResponse[];
}

/**
 * ForecastResponse
 * Weekly forecast response.
 */
export interface ForecastResponse {
  /** Week Number */
  week_number: number;
  /** Target Value */
  target_value: number;
}

/**
 * FullUserResponse
 * Complete user data response.
 */
export interface FullUserResponse {
  /** User response model. */
  user: UserResponse;
  profile?: UserProfileResponse | null;
}

/**
 * GoalExpandedResponse
 * Goal response with KPIs and programme info.
 */
export interface GoalExpandedResponse {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Is Active */
  is_active: boolean;
  /**
   * Kpis
   * @default []
   */
  kpis?: KPIResponse[];
  /**
   * Programmes
   * @default []
   */
  programmes?: ProgrammeInfo[];
  /** Progress Percent */
  progress_percent?: number | null;
}

/**
 * GoalProgressResponse
 * Goal progress using BDD rules.
 */
export interface GoalProgressResponse {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Kpis On Target */
  kpis_on_target: number;
  /** Total Kpis */
  total_kpis: number;
  /** Progress Percent */
  progress_percent?: number | null;
  /** Programme Id */
  programme_id?: string | null;
}

/**
 * GoalResponse
 * Goal response with KPIs.
 */
export interface GoalResponse {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Is Active */
  is_active: boolean;
  /**
   * Kpis
   * @default []
   */
  kpis?: KPIResponse[];
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/**
 * HabitCardResponse
 * Habit card for dashboard display.
 */
export interface HabitCardResponse {
  /** Id */
  id: string;
  /** Habit Name */
  habit_name: string;
  /** Habit Icon Url */
  habit_icon_url?: string | null;
  /** Progress Percentage */
  progress_percentage: number;
  /** Current Streak */
  current_streak: number;
  /** Days Completed */
  days_completed: number;
  /** Total Days */
  total_days: number;
  /** Min Completion Days */
  min_completion_days: number;
  /** Days Remaining */
  days_remaining: number;
  /** Can Log Today */
  can_log_today: boolean;
  /**
   * Target End Date
   * @format date
   */
  target_end_date: string;
  /** Last Logged Date */
  last_logged_date?: string | null;
  todays_positive_change?: TodaysPositiveChangeResponse | null;
  /** Behaviour Name */
  behaviour_name?: string | null;
  /** Module Name */
  module_name?: string | null;
  /** Programme Name */
  programme_name?: string | null;
}

/** HabitDetail */
export interface HabitDetail {
  /** Name */
  name: string;
  /** Avg Logs Per Week */
  avg_logs_per_week: number;
}

/** HabitImpactGroup */
export interface HabitImpactGroup {
  /** Habit Id */
  habit_id: string;
  /** Habit Name */
  habit_name: string;
  /** Habit Icon */
  habit_icon: string | null;
  /** Impact Count */
  impact_count: number;
  /** Impacts */
  impacts: ImpactEntry[];
}

/**
 * HabitLogResponse
 * Habit log response model.
 */
export interface HabitLogResponse {
  /** Id */
  id: string;
  /**
   * Log Date
   * @format date
   */
  log_date: string;
  /** Log Type */
  log_type: string;
  /** Note */
  note?: string | null;
  /**
   * Logged At
   * @format date-time
   */
  logged_at: string;
  positive_change?: HabitrackApiV1HabitsPositiveChangeResponse | null;
}

/** HabitMilestone */
export interface HabitMilestone {
  /** User Habit Id */
  user_habit_id: string;
  /** Habit Name */
  habit_name: string;
  /** Programme Name */
  programme_name: string | null;
  /** Module Name */
  module_name: string | null;
  /** Current Level */
  current_level: number;
  /** Current Level Name */
  current_level_name: string;
  /** Total Logs */
  total_logs: number;
  /** Total Required */
  total_required: number;
  /** Days Remaining */
  days_remaining: number;
  /** Has Positive Impact */
  has_positive_impact: boolean;
  /** Has Endorsement Given */
  has_endorsement_given: boolean;
  next_level: NextLevel | null;
  /** Adoption Status */
  adoption_status: string;
}

/**
 * HabitProgressResponse
 * Habit progress response model.
 */
export interface HabitProgressResponse {
  /** Habit Id */
  habit_id: string;
  /** Total Days */
  total_days: number;
  /**
   * Min Completion Days
   * @default 0
   */
  min_completion_days?: number;
  /** Days Completed */
  days_completed: number;
  /** Completion Percentage */
  completion_percentage: number;
  /** Current Streak */
  current_streak: number;
  /** Longest Streak */
  longest_streak: number;
  /** Logs This Week */
  logs_this_week: number;
  /** Logs This Month */
  logs_this_month: number;
  /** Recent Logs */
  recent_logs: HabitLogResponse[];
}

/**
 * HabitsLoggedResponse
 * Habits logged stats for KPI dashboard insights.
 */
export interface HabitsLoggedResponse {
  /** Count */
  count: number;
  /** Avg Per User */
  avg_per_user: number;
  /** Change Percent */
  change_percent: number;
  /** Trend */
  trend: string;
}

/** ImpactEntry */
export interface ImpactEntry {
  /** Description */
  description: string;
  /** Logged At */
  logged_at: string;
}

/** InitiativeActivityLine */
export interface InitiativeActivityLine {
  /** Initiative Id */
  initiative_id: string;
  /** Initiative Name */
  initiative_name: string;
  /** Weeks */
  weeks: WeekPoint[];
}

/** InitiativeCountsResponse */
export interface InitiativeCountsResponse {
  /** Streams */
  streams: number;
  /** Active Cohorts */
  active_cohorts: number;
  /** Total Users */
  total_users: number;
}

/** InitiativeInsightsResponse */
export interface InitiativeInsightsResponse {
  /** Programme Id */
  programme_id: string;
  /** Programme Name */
  programme_name: string;
  /** Accessible Programmes */
  accessible_programmes: ProgrammeRef[];
  /** Enabled Components */
  enabled_components: string[];
  counts?: InitiativeCountsResponse | null;
  stats?: InitiativeStatsResponse | null;
  activity_over_time?: ActivityOverTimeResponse | null;
  /** Distribution */
  distribution?: DistributionBucket[] | null;
  /** Top Positive Impacts */
  top_positive_impacts?: PositiveImpactItem[] | null;
  /** Streams */
  streams?: StreamSummaryRow[] | null;
}

/** InitiativeStatsResponse */
export interface InitiativeStatsResponse {
  engagement_rate: StatValue;
  consistency_rate: StatValue;
  active_users_pct: StatValue;
  users_endorsed_pct: StatValue;
}

/**
 * KPIInsightsResponse
 * Quick Insights stats for KPI dashboard.
 */
export interface KPIInsightsResponse {
  /** Kpis On Target */
  kpis_on_target: number;
  /** Total Kpis */
  total_kpis: number;
  /** Change Percent */
  change_percent: number;
  /** Trend */
  trend: string;
  most_improved_kpi?: MostImprovedKPIResponse | null;
  habits_logged?: HabitsLoggedResponse | null;
}

/** KPIProgressData */
export interface KPIProgressData {
  /** Kpi Id */
  kpi_id: string;
  /** Kpi Title */
  kpi_title: string;
  /** Weeks */
  weeks: KPIProgressWeek[];
}

/** KPIProgressWeek */
export interface KPIProgressWeek {
  /** Week Number */
  week_number: number;
  /** Current Value */
  current_value: number;
  /** Target Value */
  target_value: number;
  /** Progress Pct */
  progress_pct: number;
}

/** KPIRef */
export interface KPIRef {
  /** Id */
  id: string;
  /** Title */
  title: string;
}

/**
 * KPIResponse
 * KPI response with forecasts.
 */
export interface KPIResponse {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Unit */
  unit: string;
  /** Target Direction */
  target_direction: string;
  /** Precision */
  precision: number;
  /** Baseline */
  baseline?: number | null;
  /** Target */
  target?: number | null;
  /** Is Active */
  is_active: boolean;
  /**
   * Forecasts
   * @default []
   */
  forecasts?: ForecastResponse[];
  /**
   * Actuals
   * @default []
   */
  actuals?: ActualResponse[];
  /** Progress Percent */
  progress_percent?: number | null;
}

/** KeyKPICard */
export interface KeyKPICard {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Current Value */
  current_value?: number | null;
  /** Target */
  target?: number | null;
  /**
   * Unit
   * @default ""
   */
  unit?: string;
}

/**
 * LeaderboardHabitResponse
 * Habit entry in a leaderboard member's list.
 */
export interface LeaderboardHabitResponse {
  /** Habit Id */
  habit_id: string;
  /** Habit Name */
  habit_name: string;
  /** Endorsed This Habit Today */
  endorsed_this_habit_today: boolean;
}

/**
 * LeaderboardMemberResponse
 * Single member in the leaderboard.
 */
export interface LeaderboardMemberResponse {
  /** Rank */
  rank?: number | null;
  /** User summary for social features. */
  user: UserSummaryResponse;
  /** Active Days */
  active_days: number;
  /** Habits */
  habits: LeaderboardHabitResponse[];
  /** Endorsed All Habits Today */
  endorsed_all_habits_today: boolean;
  /** Is Active On Programme */
  is_active_on_programme: boolean;
  /** Is Current User */
  is_current_user: boolean;
}

/**
 * LeaderboardResponse
 * Full leaderboard response.
 */
export interface LeaderboardResponse {
  /** Leaderboard */
  leaderboard: LeaderboardMemberResponse[];
  /** View Type */
  view_type: string;
}

/**
 * LogHabitRequest
 * Request model for logging a habit.
 */
export interface LogHabitRequest {
  /** Log Date */
  log_date?: string | null;
  /**
   * Log Type
   * @default "completed"
   */
  log_type?: string;
  /** Note */
  note?: string | null;
  /** Positive Change Id */
  positive_change_id?: string | null;
}

/**
 * LogMoodRequest
 * Request model for logging mood.
 * @example {"mood_value":4}
 */
export interface LogMoodRequest {
  /**
   * Mood Value
   * Mood value from 1 (awful) to 5 (great)
   * @min 1
   * @max 5
   */
  mood_value: number;
}

/** MilestonesResponse */
export interface MilestonesResponse {
  /** Habits */
  habits: HabitMilestone[];
}

/** ModuleCard */
export interface ModuleCard {
  /** Module Number */
  module_number: number;
  /** Module Name */
  module_name: string;
  /** Days */
  days: number;
  /** Behaviours Count */
  behaviours_count: number;
  /** Habits Count */
  habits_count: number;
  /** Behaviours */
  behaviours: BehaviourDetail[];
}

/**
 * ModuleResponse
 * Response model for module data.
 */
export interface ModuleResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Intro Content */
  intro_content?: string | null;
  /** Sequence Order */
  sequence_order: number;
  /** Duration Days */
  duration_days: number;
  /** Max Concurrent Habits */
  max_concurrent_habits: number;
  /** Status */
  status: string;
  /**
   * Is Current
   * @default false
   */
  is_current?: boolean;
  /**
   * Is Available
   * @default false
   */
  is_available?: boolean;
  /** Available From */
  available_from?: string | null;
  /** Available Till */
  available_till?: string | null;
  /** Days Remaining */
  days_remaining?: number | null;
  /**
   * Behaviours
   * @default []
   */
  behaviours?: BehaviourResponse[];
}

/**
 * MoodEntryResponse
 * Response model for mood entry.
 */
export interface MoodEntryResponse {
  /** Id */
  id: string;
  /** Mood Value */
  mood_value?: number | null;
  /** Mood Label */
  mood_label?: string | null;
  /**
   * Mood Date
   * @format date
   */
  mood_date: string;
  /** Is Skipped */
  is_skipped: boolean;
  /** Mood Emoji */
  mood_emoji?: string | null;
}

/**
 * MoodHistoryResponse
 * Response model for mood history.
 */
export interface MoodHistoryResponse {
  /** Entries */
  entries: MoodEntryResponse[];
  /** Total Entries */
  total_entries: number;
  /** Date Range */
  date_range: Record<string, string>;
  /** Statistics */
  statistics: object;
}

/**
 * MoodWidgetResponse
 * Mood widget data for dashboard.
 */
export interface MoodWidgetResponse {
  /** Current Week */
  current_week: object;
  /** Weekly Stats */
  weekly_stats: object;
  /** Rolling Summary */
  rolling_summary: object;
  /** Benefit Message */
  benefit_message: string;
}

/**
 * MostImprovedKPIResponse
 * Most improved KPI details.
 */
export interface MostImprovedKPIResponse {
  /** Name */
  name: string;
  /** Current Value */
  current_value: number;
  /** Improvement Percent */
  improvement_percent: number;
  /** Trend */
  trend: string;
}

/** NextLevel */
export interface NextLevel {
  /** Next Level */
  next_level: number;
  /** Next Level Name */
  next_level_name: string;
  /** Requirements */
  requirements: NextLevelRequirement[];
}

/** NextLevelRequirement */
export interface NextLevelRequirement {
  /** Type */
  type: string;
  /** Target */
  target: number;
  /** Current */
  current: number;
  /** Met */
  met: boolean;
}

/** NotificationCountResponse */
export interface NotificationCountResponse {
  /** Unread */
  unread: number;
}

/**
 * ObjectiveExpandedResponse
 * Objective with full nested data including programme stats.
 */
export interface ObjectiveExpandedResponse {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Is Active */
  is_active: boolean;
  /**
   * Goals
   * @default []
   */
  goals?: GoalExpandedResponse[];
  /**
   * Direct Kpis
   * @default []
   */
  direct_kpis?: KPIResponse[];
  /**
   * Programme Stats
   * @default []
   */
  programme_stats?: ProgrammeStats[];
  /** Progress Percent */
  progress_percent?: number | null;
}

/**
 * ObjectiveProgressResponse
 * Objective progress using BDD rules.
 */
export interface ObjectiveProgressResponse {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Kpis On Target */
  kpis_on_target: number;
  /** Total Kpis */
  total_kpis: number;
  /** Progress Percent */
  progress_percent?: number | null;
  /**
   * Goals
   * @default []
   */
  goals?: GoalProgressResponse[];
}

/**
 * ObjectiveResponse
 * Objective response with goals.
 */
export interface ObjectiveResponse {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Is Active */
  is_active: boolean;
  /**
   * Goals
   * @default []
   */
  goals?: GoalResponse[];
  /**
   * Direct Kpis
   * @default []
   */
  direct_kpis?: KPIResponse[];
}

/**
 * ObjectiveSummaryResponse
 * Objective summary for list view.
 */
export interface ObjectiveSummaryResponse {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Is Active */
  is_active: boolean;
  /** Goal Count */
  goal_count: number;
  /** Kpi Count */
  kpi_count: number;
}

/** OrgBehaviourRow */
export interface OrgBehaviourRow {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Initiative Name */
  initiative_name: string;
  /** Avg Activity */
  avg_activity: number;
  /** Status */
  status: string;
  /** Status Label */
  status_label: string;
  /** Kpis On Target */
  kpis_on_target: number;
  /** Kpis Total */
  kpis_total: number;
  most_improved_kpi?: BehaviourKPIInfo | null;
  least_improved_kpi?: BehaviourKPIInfo | null;
}

/** OrgCountsResponse */
export interface OrgCountsResponse {
  /** Active Initiatives */
  active_initiatives: number;
  /** Behaviours */
  behaviours: number;
  /** Total Users */
  total_users: number;
}

/** OrganisationInsightsResponse */
export interface OrganisationInsightsResponse {
  /** Enabled Components */
  enabled_components: string[];
  counts?: OrgCountsResponse | null;
  /** Key Kpis */
  key_kpis?: KeyKPICard[] | null;
  /** All Kpis */
  all_kpis?: KPIRef[] | null;
  /** Kpi Progress */
  kpi_progress?: KPIProgressData[] | null;
  /** Distribution */
  distribution?: DistributionBucket[] | null;
  /** Activity Over Time */
  activity_over_time?: InitiativeActivityLine[] | null;
  /** Behaviours */
  behaviours?: OrgBehaviourRow[] | null;
}

/**
 * PendingOnboarding
 * Info about a programme/module that needs onboarding.
 */
export interface PendingOnboarding {
  /** Programme Id */
  programme_id: string;
  /** Programme Name */
  programme_name: string;
  /** Module Id */
  module_id: string;
  /** Module Name */
  module_name: string;
}

/**
 * PositiveChangeCount
 * Positive change count for dashboard.
 */
export interface PositiveChangeCount {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Category */
  category?: string | null;
  /** Count */
  count: number;
}

/**
 * PositiveChangesWidgetResponse
 * Positive changes widget response.
 */
export interface PositiveChangesWidgetResponse {
  /** Total Logged */
  total_logged: number;
  /** Changes */
  changes: PositiveChangeCount[];
}

/** PositiveImpactItem */
export interface PositiveImpactItem {
  /** Name */
  name: string;
  /** Count */
  count: number;
}

/** PositiveImpactsResponse */
export interface PositiveImpactsResponse {
  /** Total Count */
  total_count: number;
  /** Habits */
  habits: HabitImpactGroup[];
}

/**
 * ProgrammeInfo
 * Programme/Initiative basic info extracted from goal tags.
 */
export interface ProgrammeInfo {
  /** Id */
  id: string;
  /** Name */
  name: string;
}

/** ProgrammeRef */
export interface ProgrammeRef {
  /** Id */
  id: string;
  /** Name */
  name: string;
}

/**
 * ProgrammeResponse
 * Response model for programme data.
 */
export interface ProgrammeResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Short Description */
  short_description?: string | null;
  /** Status */
  status: string;
  /** Intro Content */
  intro_content?: string | null;
  /** Is Self Paced */
  is_self_paced: boolean;
  /**
   * Modules Count
   * @default 0
   */
  modules_count?: number;
  /**
   * Behaviours Count
   * @default 0
   */
  behaviours_count?: number;
  /**
   * Habits Count
   * @default 0
   */
  habits_count?: number;
  /** Duration Days */
  duration_days?: number | null;
  /** Current Module Id */
  current_module_id?: string | null;
  /**
   * Modules
   * @default []
   */
  modules?: ModuleResponse[];
}

/**
 * ProgrammeStats
 * Programme stats aggregated from cohorts.
 */
export interface ProgrammeStats {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /**
   * Active Users
   * @default 0
   */
  active_users?: number;
  /**
   * Cohorts Count
   * @default 0
   */
  cohorts_count?: number;
  /**
   * Delivery Stream Count
   * @default 0
   */
  delivery_stream_count?: number;
}

/**
 * ProgressChartData
 * Progress chart data for dashboard.
 */
export interface ProgressChartData {
  /** Daily Completion */
  daily_completion: Record<string, boolean>;
  /** Weekly Summary */
  weekly_summary: object[];
  /** Monthly Summary */
  monthly_summary: object;
  /** Overall Stats */
  overall_stats: object;
}

/**
 * QuizAnswer
 * Single question answer for quiz_radio type.
 */
export interface QuizAnswer {
  /** Question Id */
  question_id: string;
  /** Selected Index */
  selected_index: number;
}

/**
 * RegisterConversationRequest
 * Request model for registering Teams conversation reference.
 */
export interface RegisterConversationRequest {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Teams User Id */
  teams_user_id: string;
  /** Teams Conversation Id */
  teams_conversation_id: string;
  /** Teams Service Url */
  teams_service_url: string;
  /** Teams Tenant Id */
  teams_tenant_id: string;
}

/**
 * RegisterConversationResponse
 * Response model for conversation registration.
 */
export interface RegisterConversationResponse {
  /** Success */
  success: boolean;
  /** Message */
  message: string;
}

/**
 * SelectHabitRequest
 * Request model for selecting a habit.
 */
export interface SelectHabitRequest {
  /** Habit Id */
  habit_id: string;
  /** Start Date */
  start_date?: string | null;
}

/**
 * SendProactiveMessageRequest
 * Request model for sending proactive Teams message.
 */
export interface SendProactiveMessageRequest {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** Message */
  message?: string | null;
  /** Title */
  title?: string | null;
  /** Card Data */
  card_data?: object | null;
}

/**
 * SendProactiveMessageResponse
 * Response model for sending proactive message.
 */
export interface SendProactiveMessageResponse {
  /** Success */
  success: boolean;
  /** Message */
  message: string;
}

/** StatValue */
export interface StatValue {
  /** Value */
  value: number;
  /** Wow Delta */
  wow_delta?: number | null;
}

/** StreamDetailsResponse */
export interface StreamDetailsResponse {
  /** Stream Id */
  stream_id: string;
  /** Stream Name */
  stream_name: string;
  cohorts_overview: CohortsOverview;
  /** Behaviours Overview */
  behaviours_overview: ModuleCard[];
}

/** StreamSummaryRow */
export interface StreamSummaryRow {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Cohorts Count */
  cohorts_count: number;
  /** Behaviours Count */
  behaviours_count: number;
  /** Total Users */
  total_users: number;
  /** Active Users Pct */
  active_users_pct: number;
  /** Avg Completion */
  avg_completion?: number | null;
}

/**
 * SummarizeRequest
 * Request model for dashboard summarization.
 */
export interface SummarizeRequest {
  /**
   * Include Motivational
   * @default true
   */
  include_motivational?: boolean;
  /** Focus Areas */
  focus_areas?: string[] | null;
}

/**
 * SummarizeResponse
 * Response model for dashboard summarization.
 */
export interface SummarizeResponse {
  /** Summary */
  summary: string;
  /** Generated At */
  generated_at: string;
}

/** TaskListResponse */
export interface TaskListResponse {
  /** Tasks */
  tasks: TaskResponse[];
  /** Count */
  count: number;
}

/** TaskResponse */
export interface TaskResponse {
  /** Id */
  id: string;
  /** Type */
  type: string;
  /** Teammates */
  teammates: TaskTeammate[];
  /** Created At */
  created_at?: string | null;
}

/** TaskTeammate */
export interface TaskTeammate {
  /** User Id */
  user_id: string;
  /** Name */
  name: string;
  /** Avatar Url */
  avatar_url?: string | null;
}

/**
 * TeamWidgetResponse
 * Team widget data for dashboard.
 */
export interface TeamWidgetResponse {
  /** Cohort Name */
  cohort_name?: string | null;
  /** Team Name */
  team_name?: string | null;
  /**
   * Total Members
   * @default 0
   */
  total_members?: number;
  /** My Ranking */
  my_ranking?: number | null;
  /**
   * Top Performers
   * @default []
   */
  top_performers?: object[];
  /**
   * Recent Activity
   * @default []
   */
  recent_activity?: object[];
}

/**
 * TodaysPositiveChangeResponse
 * Today's positive change response.
 */
export interface TodaysPositiveChangeResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Category */
  category: string;
}

/** UpNextItem */
export interface UpNextItem {
  /** Type */
  type: string;
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Progress Current */
  progress_current: number;
  /** Progress Target */
  progress_target: number;
}

/**
 * UpdateProfileRequest
 * Request model for updating user profile.
 *
 * PROFILE-UPDATE-RULE-002: email, first_name, last_name, job_title are
 * immutable (sourced from customer Entra/SSO). Not accepted here.
 */
export interface UpdateProfileRequest {
  /** Bio */
  bio?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /** Timezone */
  timezone?: string | null;
  /** Email Notifications Enabled */
  email_notifications_enabled?: boolean | null;
  /** Push Notifications Enabled */
  push_notifications_enabled?: boolean | null;
  /** Daily Reminder Time */
  daily_reminder_time?: string | null;
  /** Weekly Summary Enabled */
  weekly_summary_enabled?: boolean | null;
}

/**
 * UserFlowStatusResponse
 * Response model for user flow status endpoint.
 */
export interface UserFlowStatusResponse {
  /** User Id */
  user_id: string;
  /** Has Accepted Terms */
  has_accepted_terms: boolean;
  /** Has Active Habits */
  has_active_habits: boolean;
  /** Needs Mood Entry */
  needs_mood_entry: boolean;
  /** Navigation Path */
  navigation_path: string;
  /** App role with permission flags for frontend. */
  app_role: AppRoleResponse;
  department_scope?: DepartmentScope | null;
  /**
   * Manageable Teams
   * @default []
   */
  manageable_teams?: DepartmentScope[];
  /** Program Has Started */
  program_has_started: boolean;
  /** Requires Explicit Consent */
  requires_explicit_consent: boolean;
  pending_onboarding?: PendingOnboarding | null;
  /** Ceo Video Url */
  ceo_video_url?: string | null;
  /** Platform Intro Title */
  platform_intro_title?: string | null;
  /** Platform Intro Body */
  platform_intro_body?: string | null;
}

/**
 * UserHabitResponse
 * User habit response model.
 */
export interface UserHabitResponse {
  /** Id */
  id: string;
  /** Habit response model. */
  habit: HabitrackApiV1HabitsHabitResponse;
  /**
   * Started At
   * @format date-time
   */
  started_at: string;
  /**
   * Target Completion Date
   * @format date
   */
  target_completion_date: string;
  /** Completed At */
  completed_at?: string | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  /**
   * Is Completed
   * @default false
   */
  is_completed?: boolean;
  /**
   * Completion Percentage
   * @default 0
   */
  completion_percentage?: number;
  /**
   * Current Streak
   * @default 0
   */
  current_streak?: number;
  /**
   * Total Logs
   * @default 0
   */
  total_logs?: number;
  /**
   * Days Completed
   * @default 0
   */
  days_completed?: number;
  /**
   * Days Remaining
   * @default 0
   */
  days_remaining?: number;
  /**
   * Can Log Today
   * @default true
   */
  can_log_today?: boolean;
  /**
   * Show Action
   * @default false
   */
  show_action?: boolean;
  /**
   * Show Positive Impacts
   * @default false
   */
  show_positive_impacts?: boolean;
  /** History Status */
  history_status?: string | null;
}

/**
 * UserProfileResponse
 * User profile response model.
 */
export interface UserProfileResponse {
  /** Bio */
  bio?: string | null;
  /** Avatar Url */
  avatar_url?: string | null;
  /** Phone Number */
  phone_number?: string | null;
  /**
   * Timezone
   * @default "UTC"
   */
  timezone?: string;
  /**
   * Email Notifications Enabled
   * @default true
   */
  email_notifications_enabled?: boolean;
  /**
   * Push Notifications Enabled
   * @default true
   */
  push_notifications_enabled?: boolean;
  /** Daily Reminder Time */
  daily_reminder_time?: string | null;
  /**
   * Weekly Summary Enabled
   * @default true
   */
  weekly_summary_enabled?: boolean;
  /** Terms Accepted At */
  terms_accepted_at?: string | null;
  /** Privacy Policy Accepted At */
  privacy_policy_accepted_at?: string | null;
}

/**
 * UserResponse
 * User response model.
 */
export interface UserResponse {
  /** Id */
  id: string;
  /** Email */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Full Name */
  full_name: string;
  /** Role */
  role: string;
  /** Is Active */
  is_active: boolean;
  /** Is Verified */
  is_verified: boolean;
  /** Organization Id */
  organization_id?: string | null;
  /** Job Title */
  job_title?: string | null;
  /** Last Login At */
  last_login_at?: string | null;
  /** Onboarded At */
  onboarded_at?: string | null;
}

/**
 * UserSummaryResponse
 * User summary for social features.
 */
export interface UserSummaryResponse {
  /** Id */
  id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Full Name */
  full_name: string;
  /** Email */
  email: string;
  /** Avatar Url */
  avatar_url?: string | null;
  /** Job Title */
  job_title?: string | null;
  /** Endorsed Any Habit Today */
  endorsed_any_habit_today?: boolean | null;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
  /** Input */
  input?: any;
  /** Context */
  ctx?: object;
}

/** WeekPoint */
export interface WeekPoint {
  /** Week Start */
  week_start: string;
  /** Avg Days Logged */
  avg_days_logged: number;
}

/**
 * NotificationResponse
 * Notification for dashboard.
 */
export interface HabitrackApiV1DashboardNotificationResponse {
  /** Id */
  id: string;
  /** Type */
  type: string;
  /** Title */
  title: string;
  /** Message */
  message: string;
  /** Is Read */
  is_read: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Action Url */
  action_url?: string | null;
}

/**
 * HabitResponse
 * Habit response model.
 */
export interface HabitrackApiV1HabitsHabitResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Instructions */
  instructions?: string | null;
  /** Difficulty */
  difficulty: string;
  /** Estimated Time Minutes */
  estimated_time_minutes?: number | null;
  /**
   * Is Custom
   * @default false
   */
  is_custom?: boolean;
  /**
   * Default Duration Days
   * @default 60
   */
  default_duration_days?: number;
  /**
   * Min Completion Days
   * @default 48
   */
  min_completion_days?: number;
  /**
   * Max Extension Days
   * @default 20
   */
  max_extension_days?: number;
  /** Tips */
  tips?: string | null;
  /** Icon Url */
  icon_url?: string | null;
  /** Behaviour Name */
  behaviour_name?: string | null;
  /** Module Name */
  module_name?: string | null;
  /** Programme Name */
  programme_name?: string | null;
  /**
   * Positive Changes
   * @default []
   */
  positive_changes?: HabitrackApiV1HabitsPositiveChangeResponse[];
}

/**
 * PositiveChangeResponse
 * Positive change response model.
 */
export interface HabitrackApiV1HabitsPositiveChangeResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Category */
  category?: string | null;
}

/** NotificationResponse */
export interface HabitrackApiV1NotificationsNotificationResponse {
  /** Id */
  id: string;
  /** Type */
  type: string;
  /** Title */
  title: string;
  /** Message */
  message: string;
  /** Is Read */
  is_read: boolean;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Action Url */
  action_url?: string | null;
  /** Data */
  data?: object | null;
}

/**
 * HabitResponse
 * Response model for habit data.
 */
export interface HabitrackApiV1ProgrammesHabitResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Instructions */
  instructions?: string | null;
  /** Difficulty */
  difficulty: string;
  /** Estimated Time Minutes */
  estimated_time_minutes?: number | null;
  /** Default Duration Days */
  default_duration_days: number;
  /** Tips */
  tips?: string | null;
  /** Icon Url */
  icon_url?: string | null;
  /**
   * Positive Changes
   * @default []
   */
  positive_changes?: HabitrackApiV1ProgrammesPositiveChangeResponse[];
}

/**
 * PositiveChangeResponse
 * Response model for positive change data.
 */
export interface HabitrackApiV1ProgrammesPositiveChangeResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Category */
  category?: string | null;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        },
        signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
        body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title HabiTrack API
 * @version 1.0.0
 *
 * Backend API for HabiTrack habit tracking application
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Root endpoint with API information.
   *
   * @name RootGet
   * @summary Root
   * @request GET:/
   */
  rootGet = (params: RequestParams = {}) =>
    this.http.request<any, any>({
      path: `/`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  health = {
    /**
     * @description Health check endpoint.
     *
     * @name HealthHealthGet
     * @summary Health
     * @request GET:/health
     */
    healthHealthGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/health`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  ready = {
    /**
     * @description Readiness check endpoint.
     *
     * @name ReadyReadyGet
     * @summary Ready
     * @request GET:/ready
     */
    readyReadyGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/ready`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  live = {
    /**
     * @description Liveness check endpoint.
     *
     * @name LiveLiveGet
     * @summary Live
     * @request GET:/live
     */
    liveLiveGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/live`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  sentryDebug = {
    /**
     * @description Trigger a test error for Sentry verification.
     *
     * @name TriggerErrorSentryDebugGet
     * @summary Trigger Error
     * @request GET:/sentry-debug
     */
    triggerErrorSentryDebugGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/sentry-debug`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  api = {
    /**
     * @description Check which IDP to use for a given email address. Returns IDP type and configuration for frontend routing.
     *
     * @tags authentication
     * @name CheckDomainApiV1AuthCheckDomainPost
     * @summary Check Domain
     * @request POST:/api/v1/auth/check-domain
     * @secure
     */
    checkDomainApiV1AuthCheckDomainPost: (data: CheckDomainRequest, params: RequestParams = {}) =>
      this.http.request<CheckDomainResponse, HTTPValidationError>({
        path: `/api/v1/auth/check-domain`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description OB-FIRST-LOGIC-001: Mark platform onboarding as complete.
     *
     * @tags authentication
     * @name CompletePlatformOnboardingApiV1AuthCompletePlatformOnboardingPost
     * @summary Complete Platform Onboarding
     * @request POST:/api/v1/auth/complete-platform-onboarding
     * @secure
     */
    completePlatformOnboardingApiV1AuthCompletePlatformOnboardingPost: (
      params: RequestParams = {},
    ) =>
      this.http.request<any, any>({
        path: `/api/v1/auth/complete-platform-onboarding`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description PROFILE-AVATAR: Upload/replace user avatar image.
     *
     * @tags authentication
     * @name UploadAvatarApiV1AuthAvatarPost
     * @summary Upload Avatar
     * @request POST:/api/v1/auth/avatar
     * @secure
     */
    uploadAvatarApiV1AuthAvatarPost: (
      data: BodyUploadAvatarApiV1AuthAvatarPost,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/api/v1/auth/avatar`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Remove user's avatar (set to null).
     *
     * @tags authentication
     * @name DeleteAvatarApiV1AuthAvatarDelete
     * @summary Delete Avatar
     * @request DELETE:/api/v1/auth/avatar
     * @secure
     */
    deleteAvatarApiV1AuthAvatarDelete: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/auth/avatar`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get current user's profile information.
     *
     * @tags authentication
     * @name GetCurrentUserProfileApiV1AuthMeGet
     * @summary Get Current User Profile
     * @request GET:/api/v1/auth/me
     * @secure
     */
    getCurrentUserProfileApiV1AuthMeGet: (params: RequestParams = {}) =>
      this.http.request<FullUserResponse, any>({
        path: `/api/v1/auth/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Accept terms of service and privacy policy.
     *
     * @tags authentication
     * @name AcceptTermsAndPrivacyApiV1AuthAcceptTermsPost
     * @summary Accept Terms And Privacy
     * @request POST:/api/v1/auth/accept-terms
     * @secure
     */
    acceptTermsAndPrivacyApiV1AuthAcceptTermsPost: (
      data: AcceptTermsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/api/v1/auth/accept-terms`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update user profile information. PROFILE-UPDATE-RULE-002: email, first_name, last_name, job_title are immutable (managed by customer Entra/SSO directory). Not updated here.
     *
     * @tags authentication
     * @name UpdateUserProfileApiV1AuthProfilePut
     * @summary Update User Profile
     * @request PUT:/api/v1/auth/profile
     * @secure
     */
    updateUserProfileApiV1AuthProfilePut: (
      data: UpdateProfileRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<FullUserResponse, HTTPValidationError>({
        path: `/api/v1/auth/profile`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Debug endpoint to test token validation. Only registered in dev environments.
     *
     * @tags authentication
     * @name DebugTokenValidationApiV1AuthDebugTokenGet
     * @summary Debug Token Validation
     * @request GET:/api/v1/auth/debug-token
     * @secure
     */
    debugTokenValidationApiV1AuthDebugTokenGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/auth/debug-token`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Simple endpoint to test basic authentication. Only registered in dev environments.
     *
     * @tags authentication
     * @name SimpleAuthTestApiV1AuthSimpleTestGet
     * @summary Simple Auth Test
     * @request GET:/api/v1/auth/simple-test
     * @secure
     */
    simpleAuthTestApiV1AuthSimpleTestGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/auth/simple-test`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get comprehensive user flow status for determining navigation path. Multi-programme aware: checks ALL active enrolments for pending onboarding, aggregates active habits across all programmes.
     *
     * @tags authentication
     * @name GetUserFlowStatusApiV1AuthUserFlowStatusGet
     * @summary Get User Flow Status
     * @request GET:/api/v1/auth/user-flow-status
     * @secure
     */
    getUserFlowStatusApiV1AuthUserFlowStatusGet: (params: RequestParams = {}) =>
      this.http.request<UserFlowStatusResponse, any>({
        path: `/api/v1/auth/user-flow-status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reset user data for development purposes - clears habits, logs, and terms acceptance.
     *
     * @tags authentication
     * @name ResetUserDataApiV1AuthResetUserDataPost
     * @summary Reset User Data
     * @request POST:/api/v1/auth/reset-user-data
     * @secure
     */
    resetUserDataApiV1AuthResetUserDataPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/auth/reset-user-data`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reset demo data for fresh demos. Clears: - habit_logs and action_responses: last 2 days (FE allows logging yesterday) - endorsements, user_habits, mood_entries: today only Preserves historical data for impressive insight charts.
     *
     * @tags authentication
     * @name ResetDemoDataApiV1AuthResetDemoDataPost
     * @summary Reset Demo Data
     * @request POST:/api/v1/auth/reset-demo-data
     * @secure
     */
    resetDemoDataApiV1AuthResetDemoDataPost: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/auth/reset-demo-data`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get available habits for selection, filtered to user's stream modules across all programmes.
     *
     * @tags habits
     * @name GetAvailableHabitsApiV1HabitsGet
     * @summary Get Available Habits
     * @request GET:/api/v1/habits/
     * @secure
     */
    getAvailableHabitsApiV1HabitsGet: (
      query?: {
        /**
         * Include Custom
         * Include custom organization habits
         * @default true
         */
        include_custom?: boolean;
        /**
         * Behaviour Id
         * Filter by behaviour ID
         */
        behaviour_id?: string | null;
        /**
         * Programme Id
         * Scope to a specific programme
         */
        programme_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<HabitrackApiV1HabitsHabitResponse[], HTTPValidationError>({
        path: `/api/v1/habits/`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get user's active habits, or full history when include_history=true.
     *
     * @tags habits
     * @name GetMyActiveHabitsApiV1HabitsMyActiveGet
     * @summary Get My Active Habits
     * @request GET:/api/v1/habits/my-active
     * @secure
     */
    getMyActiveHabitsApiV1HabitsMyActiveGet: (
      query?: {
        /**
         * Include History
         * Include all habits (active, complete, incomplete) for history view
         * @default false
         */
        include_history?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<UserHabitResponse[], HTTPValidationError>({
        path: `/api/v1/habits/my-active`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get detailed information about a specific habit.
     *
     * @tags habits
     * @name GetHabitDetailsApiV1HabitsHabitIdGet
     * @summary Get Habit Details
     * @request GET:/api/v1/habits/{habit_id}
     * @secure
     */
    getHabitDetailsApiV1HabitsHabitIdGet: (habitId: string, params: RequestParams = {}) =>
      this.http.request<HabitrackApiV1HabitsHabitResponse, HTTPValidationError>({
        path: `/api/v1/habits/${habitId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a custom habit.
     *
     * @tags habits
     * @name CreateCustomHabitApiV1HabitsCustomPost
     * @summary Create Custom Habit
     * @request POST:/api/v1/habits/custom
     * @secure
     */
    createCustomHabitApiV1HabitsCustomPost: (
      data: CreateCustomHabitRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<HabitrackApiV1HabitsHabitResponse, HTTPValidationError>({
        path: `/api/v1/habits/custom`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Select a habit to work on.
     *
     * @tags habits
     * @name SelectHabitApiV1HabitsSelectPost
     * @summary Select Habit
     * @request POST:/api/v1/habits/select
     * @secure
     */
    selectHabitApiV1HabitsSelectPost: (data: SelectHabitRequest, params: RequestParams = {}) =>
      this.http.request<UserHabitResponse, HTTPValidationError>({
        path: `/api/v1/habits/select`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Log habit completion for a specific date.
     *
     * @tags habits
     * @name LogHabitApiV1HabitsUserHabitIdLogPost
     * @summary Log Habit
     * @request POST:/api/v1/habits/{user_habit_id}/log
     * @secure
     */
    logHabitApiV1HabitsUserHabitIdLogPost: (
      userHabitId: string,
      data: LogHabitRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<HabitLogResponse, HTTPValidationError>({
        path: `/api/v1/habits/${userHabitId}/log`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get detailed progress for a specific habit.
     *
     * @tags habits
     * @name GetHabitProgressApiV1HabitsUserHabitIdProgressGet
     * @summary Get Habit Progress
     * @request GET:/api/v1/habits/{user_habit_id}/progress
     * @secure
     */
    getHabitProgressApiV1HabitsUserHabitIdProgressGet: (
      userHabitId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<HabitProgressResponse, HTTPValidationError>({
        path: `/api/v1/habits/${userHabitId}/progress`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get action types for the picker screen. Returns action types ordered by "least selected" - types where the user has the fewest completed ActionResponses for this habit.
     *
     * @tags habits
     * @name GetActionTypesForPickerApiV1HabitsHabitIdActionTypesGet
     * @summary Get Action Types For Picker
     * @request GET:/api/v1/habits/{habit_id}/action-types
     * @secure
     */
    getActionTypesForPickerApiV1HabitsHabitIdActionTypesGet: (
      habitId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<ActionTypePickerResponse, HTTPValidationError>({
        path: `/api/v1/habits/${habitId}/action-types`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the action questionnaire for an action-based habit.
     *
     * @tags habits
     * @name GetHabitActionApiV1HabitsHabitIdActionGet
     * @summary Get Habit Action
     * @request GET:/api/v1/habits/{habit_id}/action
     * @secure
     */
    getHabitActionApiV1HabitsHabitIdActionGet: (
      habitId: string,
      query?: {
        /**
         * Action Type Id
         * Filter to specific action type from picker
         */
        action_type_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ActionGetResponse, HTTPValidationError>({
        path: `/api/v1/habits/${habitId}/action`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Submit response to action questionnaire and auto-log habit completion.
     *
     * @tags habits
     * @name SubmitActionResponseApiV1HabitsUserHabitIdActionResponsePost
     * @summary Submit Action Response
     * @request POST:/api/v1/habits/{user_habit_id}/action-response
     * @secure
     */
    submitActionResponseApiV1HabitsUserHabitIdActionResponsePost: (
      userHabitId: string,
      data: ActionResponseRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<ActionResponseResult, HTTPValidationError>({
        path: `/api/v1/habits/${userHabitId}/action-response`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return the list of valid endorsement options for the endorsement modal.
     *
     * @tags social
     * @name GetEndorsementOptionsApiV1SocialEndorsementOptionsGet
     * @summary Get Endorsement Options
     * @request GET:/api/v1/social/endorsement-options
     * @secure
     */
    getEndorsementOptionsApiV1SocialEndorsementOptionsGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/social/endorsement-options`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get cohort members and their progress.
     *
     * @tags social
     * @name GetCohortMembersApiV1SocialCohortMembersGet
     * @summary Get Cohort Members
     * @request GET:/api/v1/social/cohort/members
     * @secure
     */
    getCohortMembersApiV1SocialCohortMembersGet: (params: RequestParams = {}) =>
      this.http.request<CohortMemberProgressResponse[], any>({
        path: `/api/v1/social/cohort/members`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create an endorsement for another user's habit.
     *
     * @tags social
     * @name CreateEndorsementApiV1SocialEndorsementsPost
     * @summary Create Endorsement
     * @request POST:/api/v1/social/endorsements
     * @secure
     */
    createEndorsementApiV1SocialEndorsementsPost: (
      data: CreateEndorsementRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<EndorsementResponse, HTTPValidationError>({
        path: `/api/v1/social/endorsements`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get recent endorsements in user's cohorts.
     *
     * @tags social
     * @name GetRecentEndorsementsApiV1SocialEndorsementsGet
     * @summary Get Recent Endorsements
     * @request GET:/api/v1/social/endorsements
     * @secure
     */
    getRecentEndorsementsApiV1SocialEndorsementsGet: (
      query?: {
        /**
         * Limit
         * @min 1
         * @max 50
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<EndorsementResponse[], HTTPValidationError>({
        path: `/api/v1/social/endorsements`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a comment on a habit log.
     *
     * @tags social
     * @name CreateCommentApiV1SocialCommentsPost
     * @summary Create Comment
     * @request POST:/api/v1/social/comments
     * @secure
     */
    createCommentApiV1SocialCommentsPost: (
      data: CreateCommentRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<CommentResponse, HTTPValidationError>({
        path: `/api/v1/social/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get leaderboard ranked by days active in last 7 days. Supports team and programme_peers views (LEADERBOARD-LOGIC-007).
     *
     * @tags social
     * @name GetLeaderboardApiV1SocialLeaderboardGet
     * @summary Get Leaderboard
     * @request GET:/api/v1/social/leaderboard
     * @secure
     */
    getLeaderboardApiV1SocialLeaderboardGet: (
      query?: {
        /**
         * Limit
         * @min 1
         * @max 50
         * @default 10
         */
        limit?: number;
        /** View Type */
        view_type?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LeaderboardResponse, HTTPValidationError>({
        path: `/api/v1/social/leaderboard`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get comprehensive dashboard data for the main screen.
     *
     * @tags dashboard
     * @name GetDashboardDataApiV1DashboardGet
     * @summary Get Dashboard Data
     * @request GET:/api/v1/dashboard/
     * @secure
     */
    getDashboardDataApiV1DashboardGet: (params: RequestParams = {}) =>
      this.http.request<DashboardResponse, any>({
        path: `/api/v1/dashboard/`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get just the habit cards for dashboard (for quick updates).
     *
     * @tags dashboard
     * @name GetDashboardHabitsApiV1DashboardHabitsGet
     * @summary Get Dashboard Habits
     * @request GET:/api/v1/dashboard/habits
     * @secure
     */
    getDashboardHabitsApiV1DashboardHabitsGet: (params: RequestParams = {}) =>
      this.http.request<HabitCardResponse[], any>({
        path: `/api/v1/dashboard/habits`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get progress chart data for specified number of days.
     *
     * @tags dashboard
     * @name GetProgressChartDataApiV1DashboardProgressGet
     * @summary Get Progress Chart Data
     * @request GET:/api/v1/dashboard/progress
     * @secure
     */
    getProgressChartDataApiV1DashboardProgressGet: (
      query?: {
        /**
         * Days
         * @default 30
         */
        days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ProgressChartData, HTTPValidationError>({
        path: `/api/v1/dashboard/progress`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get team widget data for dashboard.
     *
     * @tags dashboard
     * @name GetTeamWidgetDataApiV1DashboardTeamGet
     * @summary Get Team Widget Data
     * @request GET:/api/v1/dashboard/team
     * @secure
     */
    getTeamWidgetDataApiV1DashboardTeamGet: (params: RequestParams = {}) =>
      this.http.request<TeamWidgetResponse, any>({
        path: `/api/v1/dashboard/team`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get quick statistics for dashboard.
     *
     * @tags dashboard
     * @name GetQuickStatsApiV1DashboardStatsGet
     * @summary Get Quick Stats
     * @request GET:/api/v1/dashboard/stats
     * @secure
     */
    getQuickStatsApiV1DashboardStatsGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/dashboard/stats`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get programmes assigned to the current user via cohort membership.
     *
     * @tags programmes
     * @name GetAvailableProgrammesApiV1ProgrammesGet
     * @summary Get Available Programmes
     * @request GET:/api/v1/programmes/
     * @secure
     */
    getAvailableProgrammesApiV1ProgrammesGet: (
      query?: {
        /**
         * Include Inactive
         * Include inactive programmes
         * @default false
         */
        include_inactive?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ProgrammeResponse[], HTTPValidationError>({
        path: `/api/v1/programmes/`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get ALL of the user's active programmes (multi-programme aware).
     *
     * @tags programmes
     * @name GetUserActiveProgrammesApiV1ProgrammesActiveGet
     * @summary Get User Active Programmes
     * @request GET:/api/v1/programmes/active
     * @secure
     */
    getUserActiveProgrammesApiV1ProgrammesActiveGet: (params: RequestParams = {}) =>
      this.http.request<ProgrammeResponse[], any>({
        path: `/api/v1/programmes/active`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated -- use GET /programmes/active or GET /programmes/{id}.
     *
     * @tags programmes
     * @name GetUserCurrentProgrammeDeprecatedApiV1ProgrammesCurrentGet
     * @summary Get User Current Programme Deprecated
     * @request GET:/api/v1/programmes/current
     * @secure
     */
    getUserCurrentProgrammeDeprecatedApiV1ProgrammesCurrentGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/programmes/current`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a specific programme by ID.
     *
     * @tags programmes
     * @name GetProgrammeApiV1ProgrammesProgrammeIdGet
     * @summary Get Programme
     * @request GET:/api/v1/programmes/{programme_id}
     * @secure
     */
    getProgrammeApiV1ProgrammesProgrammeIdGet: (programmeId: string, params: RequestParams = {}) =>
      this.http.request<ProgrammeResponse, HTTPValidationError>({
        path: `/api/v1/programmes/${programmeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get all behaviours for a programme with their associated habits. This endpoint is useful for the behaviour/habit selection screen.
     *
     * @tags programmes
     * @name GetProgrammeBehavioursWithHabitsApiV1ProgrammesProgrammeIdBehavioursGet
     * @summary Get Programme Behaviours With Habits
     * @request GET:/api/v1/programmes/{programme_id}/behaviours
     * @secure
     */
    getProgrammeBehavioursWithHabitsApiV1ProgrammesProgrammeIdBehavioursGet: (
      programmeId: string,
      query?: {
        /**
         * Module Id
         * Filter by specific module
         */
        module_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<BehaviourWithHabitsResponse[], HTTPValidationError>({
        path: `/api/v1/programmes/${programmeId}/behaviours`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the current active module for a programme.
     *
     * @tags programmes
     * @name GetCurrentModuleApiV1ProgrammesProgrammeIdCurrentModuleGet
     * @summary Get Current Module
     * @request GET:/api/v1/programmes/{programme_id}/current-module
     * @secure
     */
    getCurrentModuleApiV1ProgrammesProgrammeIdCurrentModuleGet: (
      programmeId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<ModuleResponse | null, HTTPValidationError>({
        path: `/api/v1/programmes/${programmeId}/current-module`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Log daily mood entry.
     *
     * @tags mood
     * @name LogMoodApiV1MoodPost
     * @summary Log Mood
     * @request POST:/api/v1/mood/
     * @secure
     */
    logMoodApiV1MoodPost: (data: LogMoodRequest, params: RequestParams = {}) =>
      this.http.request<MoodEntryResponse, HTTPValidationError>({
        path: `/api/v1/mood/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Skip mood entry for today.
     *
     * @tags mood
     * @name SkipMoodApiV1MoodSkipPost
     * @summary Skip Mood
     * @request POST:/api/v1/mood/skip
     * @secure
     */
    skipMoodApiV1MoodSkipPost: (params: RequestParams = {}) =>
      this.http.request<MoodEntryResponse, any>({
        path: `/api/v1/mood/skip`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get mood history for specified number of days.
     *
     * @tags mood
     * @name GetMoodHistoryApiV1MoodHistoryGet
     * @summary Get Mood History
     * @request GET:/api/v1/mood/history
     * @secure
     */
    getMoodHistoryApiV1MoodHistoryGet: (
      query?: {
        /**
         * Days
         * @default 30
         */
        days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<MoodHistoryResponse, HTTPValidationError>({
        path: `/api/v1/mood/history`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Generate an AI summary of the user's dashboard data. This endpoint fetches the user's dashboard and creates a natural language summary of their habit tracking progress, achievements, and areas for improvement.
     *
     * @tags assistant
     * @name SummarizeDashboardApiV1AssistantSummarizePost
     * @summary Summarize Dashboard
     * @request POST:/api/v1/assistant/summarize
     * @secure
     */
    summarizeDashboardApiV1AssistantSummarizePost: (
      data: SummarizeRequest | null,
      params: RequestParams = {},
    ) =>
      this.http.request<SummarizeResponse, HTTPValidationError>({
        path: `/api/v1/assistant/summarize`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Have a conversational interaction about the user's dashboard data. This endpoint allows users to ask questions about their habit tracking data and receive contextual AI-generated responses.
     *
     * @tags assistant
     * @name ChatAboutDashboardApiV1AssistantChatPost
     * @summary Chat About Dashboard
     * @request POST:/api/v1/assistant/chat
     * @secure
     */
    chatAboutDashboardApiV1AssistantChatPost: (data: ChatRequest, params: RequestParams = {}) =>
      this.http.request<ChatResponse, HTTPValidationError>({
        path: `/api/v1/assistant/chat`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Check the status of the AI assistant service. Returns whether the assistant is properly configured and available.
     *
     * @tags assistant
     * @name GetAssistantStatusApiV1AssistantStatusGet
     * @summary Get Assistant Status
     * @request GET:/api/v1/assistant/status
     * @secure
     */
    getAssistantStatusApiV1AssistantStatusGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/assistant/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Register or update a Teams conversation reference for a user. This endpoint is called by the Teams bot when a user first interacts with it. Requires X-Teams-Bot-Secret header for authentication. Args: request: Conversation registration data db: Database session _: Teams bot secret verification dependency Returns: RegisterConversationResponse: Success status and message Raises: HTTPException: If user not found
     *
     * @tags teams
     * @name RegisterConversationApiV1TeamsRegisterConversationPost
     * @summary Register Conversation
     * @request POST:/api/v1/teams/register-conversation
     * @secure
     */
    registerConversationApiV1TeamsRegisterConversationPost: (
      data: RegisterConversationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<RegisterConversationResponse, HTTPValidationError>({
        path: `/api/v1/teams/register-conversation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send a proactive message to a user via Teams bot. Authentication: Supports two methods: 1. OAuth: User must have super_admin role 2. Service: Must provide X-Notification-Service-Secret header Args: request: Message send request with user_id and message content db: Database session current_user: Current authenticated user (None if service auth) Returns: SendProactiveMessageResponse: Success status and message Raises: HTTPException: If not authorized, user not found, or bot communication fails
     *
     * @tags teams
     * @name SendProactiveMessageApiV1TeamsAdminSendMessagePost
     * @summary Send Proactive Message
     * @request POST:/api/v1/teams/admin/send-message
     * @secure
     */
    sendProactiveMessageApiV1TeamsAdminSendMessagePost: (
      data: SendProactiveMessageRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<SendProactiveMessageResponse, HTTPValidationError>({
        path: `/api/v1/teams/admin/send-message`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all objectives for the current user's organization. Returns a summary view with goal/KPI counts. Data is fetched from habitrack-data service.
     *
     * @tags kpi
     * @name ListObjectivesApiV1KpiObjectivesGet
     * @summary List Objectives
     * @request GET:/api/v1/kpi/objectives
     * @secure
     */
    listObjectivesApiV1KpiObjectivesGet: (
      query?: {
        /**
         * Active Only
         * @default true
         */
        active_only?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ObjectiveSummaryResponse[], HTTPValidationError>({
        path: `/api/v1/kpi/objectives`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get progress for all objectives using BDD rules. Progress is calculated as percentage of KPIs on target, using: - KPI-SCOPE-001: Only KPIs with measurements - KPI-SCOPE-002: Only KPIs whose Goal is mapped to a Programme - KPI-SCOPE-003: Only measurements within programme date window - KPI-CALC-001: Expected value via linear interpolation - KPI-CALC-002: Direction-aware comparison (Increase/Decrease) Returns progress breakdown by objective and goal. Multi-tenant: Only returns data for user's organization.
     *
     * @tags kpi
     * @name GetObjectivesProgressApiV1KpiObjectivesProgressGet
     * @summary Get Objectives Progress
     * @request GET:/api/v1/kpi/objectives/progress
     * @secure
     */
    getObjectivesProgressApiV1KpiObjectivesProgressGet: (params: RequestParams = {}) =>
      this.http.request<AllObjectivesProgressResponse, any>({
        path: `/api/v1/kpi/objectives/progress`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get detailed objective with all goals, KPIs, and measurements. Multi-tenant: Only returns data for user's organization.
     *
     * @tags kpi
     * @name GetObjectiveApiV1KpiObjectivesObjectiveIdGet
     * @summary Get Objective
     * @request GET:/api/v1/kpi/objectives/{objective_id}
     * @secure
     */
    getObjectiveApiV1KpiObjectivesObjectiveIdGet: (
      objectiveId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<ObjectiveResponse, HTTPValidationError>({
        path: `/api/v1/kpi/objectives/${objectiveId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get expanded objective with all goals, KPIs, measurements, and programme stats. Returns full nested data for dashboard expanded card view including: - Goals with their KPIs and calculated progress - Programme info extracted from goal tags - Aggregated programme stats (active users, cohort counts) from habitrack-api DB Multi-tenant: Only returns data for user's organization.
     *
     * @tags kpi
     * @name GetObjectiveExpandedApiV1KpiObjectivesObjectiveIdExpandedGet
     * @summary Get Objective Expanded
     * @request GET:/api/v1/kpi/objectives/{objective_id}/expanded
     * @secure
     */
    getObjectiveExpandedApiV1KpiObjectivesObjectiveIdExpandedGet: (
      objectiveId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<ObjectiveExpandedResponse, HTTPValidationError>({
        path: `/api/v1/kpi/objectives/${objectiveId}/expanded`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get single KPI with all measurements. Multi-tenant: Only returns data for user's organization.
     *
     * @tags kpi
     * @name GetKpiApiV1KpiKpisKpiIdGet
     * @summary Get Kpi
     * @request GET:/api/v1/kpi/kpis/{kpi_id}
     * @secure
     */
    getKpiApiV1KpiKpisKpiIdGet: (kpiId: string, params: RequestParams = {}) =>
      this.http.request<KPIResponse, HTTPValidationError>({
        path: `/api/v1/kpi/kpis/${kpiId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get complete KPI hierarchy for the organization. Returns all objectives with their goals, KPIs, and measurements. Useful for dashboard views that need the full dataset.
     *
     * @tags kpi
     * @name GetAllKpiDataApiV1KpiAllGet
     * @summary Get All Kpi Data
     * @request GET:/api/v1/kpi/all
     * @secure
     */
    getAllKpiDataApiV1KpiAllGet: (
      query?: {
        /**
         * Active Only
         * @default true
         */
        active_only?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ObjectiveResponse[], HTTPValidationError>({
        path: `/api/v1/kpi/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Quick Insights stats for KPI dashboard. Business rules implemented (see habitrack-docs/kpi.bdd): - KPI-SCOPE-001: Only KPIs with measurements are counted - KPI-SCOPE-002: Only KPIs whose Goal is mapped to a Programme - KPI-SCOPE-003: Only measurements within programme date window - KPI-CALC-001: Expected value via linear interpolation - KPI-CALC-002: Direction-aware comparison (Increase/Decrease) - KPI-CALC-003: Precision used for comparisons Multi-tenant: Only returns data for user's organization.
     *
     * @tags kpi
     * @name GetKpiInsightsApiV1KpiInsightsGet
     * @summary Get Kpi Insights
     * @request GET:/api/v1/kpi/insights
     * @secure
     */
    getKpiInsightsApiV1KpiInsightsGet: (
      query?: {
        /**
         * Programme Id
         * Filter insights to a single programme/initiative
         */
        programme_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<KPIInsightsResponse, HTTPValidationError>({
        path: `/api/v1/kpi/insights`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get goals assigned to a programme/initiative with their KPIs. Programme = Initiative in business terminology. Used by Initiative Summary page to filter goals by selected programme. Multi-tenant: Only returns data for user's organization.
     *
     * @tags kpi
     * @name GetProgrammeGoalsApiV1KpiProgrammesProgrammeIdGoalsGet
     * @summary Get Programme Goals
     * @request GET:/api/v1/kpi/programmes/{programme_id}/goals
     * @secure
     */
    getProgrammeGoalsApiV1KpiProgrammesProgrammeIdGoalsGet: (
      programmeId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<GoalResponse[], HTTPValidationError>({
        path: `/api/v1/kpi/programmes/${programmeId}/goals`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return per-habit milestone progression for the authenticated user.
     *
     * @tags insights
     * @name GetMilestonesApiV1InsightsMilestonesGet
     * @summary Get Milestones
     * @request GET:/api/v1/insights/milestones
     * @secure
     */
    getMilestonesApiV1InsightsMilestonesGet: (params: RequestParams = {}) =>
      this.http.request<MilestonesResponse, any>({
        path: `/api/v1/insights/milestones`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return endorsements given or received by the authenticated user, scoped to active habits.
     *
     * @tags insights
     * @name GetEndorsementsApiV1InsightsEndorsementsGet
     * @summary Get Endorsements
     * @request GET:/api/v1/insights/endorsements
     * @secure
     */
    getEndorsementsApiV1InsightsEndorsementsGet: (
      query: {
        /** given or received */
        direction: EndorsementDirection;
        /**
         * Limit
         * Number of items to return
         * @min 1
         * @default 5
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<EndorsementsResponse, HTTPValidationError>({
        path: `/api/v1/insights/endorsements`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return positive impacts logged by the authenticated user, grouped by habit, scoped to active habits.
     *
     * @tags insights
     * @name GetPositiveImpactsApiV1InsightsPositiveImpactsGet
     * @summary Get Positive Impacts
     * @request GET:/api/v1/insights/positive-impacts
     * @secure
     */
    getPositiveImpactsApiV1InsightsPositiveImpactsGet: (
      query?: {
        /**
         * Limit
         * Max impact entries to return across all habits
         * @min 1
         * @default 5
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PositiveImpactsResponse, HTTPValidationError>({
        path: `/api/v1/insights/positive-impacts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return initiative-level insights dashboard for a programme.
     *
     * @tags insights
     * @name GetInitiativeInsightsApiV1InsightsInitiativeProgrammeIdGet
     * @summary Get Initiative Insights
     * @request GET:/api/v1/insights/initiative/{programme_id}
     * @secure
     */
    getInitiativeInsightsApiV1InsightsInitiativeProgrammeIdGet: (
      programmeId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<InitiativeInsightsResponse, HTTPValidationError>({
        path: `/api/v1/insights/initiative/${programmeId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return stream details for the initiative insights modal.
     *
     * @tags insights
     * @name GetInitiativeStreamDetailsApiV1InsightsInitiativeProgrammeIdStreamsStreamIdGet
     * @summary Get Initiative Stream Details
     * @request GET:/api/v1/insights/initiative/{programme_id}/streams/{stream_id}
     * @secure
     */
    getInitiativeStreamDetailsApiV1InsightsInitiativeProgrammeIdStreamsStreamIdGet: (
      programmeId: string,
      streamId: string,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Page Size
         * @min 1
         * @max 100
         * @default 20
         */
        page_size?: number;
        /**
         * Sort By
         * Column to sort cohorts by
         * @default "name"
         */
        sort_by?: string;
        /**
         * Sort Dir
         * Sort direction: asc or desc
         * @default "asc"
         */
        sort_dir?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<StreamDetailsResponse, HTTPValidationError>({
        path: `/api/v1/insights/initiative/${programmeId}/streams/${streamId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return organisation-level insights dashboard.
     *
     * @tags insights
     * @name GetOrganisationInsightsApiV1InsightsOrganisationGet
     * @summary Get Organisation Insights
     * @request GET:/api/v1/insights/organisation
     * @secure
     */
    getOrganisationInsightsApiV1InsightsOrganisationGet: (params: RequestParams = {}) =>
      this.http.request<OrganisationInsightsResponse, any>({
        path: `/api/v1/insights/organisation`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return all 20 badges with status, counter, and copy for the authenticated user.
     *
     * @tags achievements
     * @name GetBadgesApiV1AchievementsBadgesGet
     * @summary Get Badges
     * @request GET:/api/v1/achievements/badges
     * @secure
     */
    getBadgesApiV1AchievementsBadgesGet: (params: RequestParams = {}) =>
      this.http.request<BadgesResponse, any>({
        path: `/api/v1/achievements/badges`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description NOTIF-DRAWER-001: List notifications for bell drawer, newest first.
     *
     * @tags notifications
     * @name GetNotificationsApiV1NotificationsGet
     * @summary Get Notifications
     * @request GET:/api/v1/notifications
     * @secure
     */
    getNotificationsApiV1NotificationsGet: (params: RequestParams = {}) =>
      this.http.request<HabitrackApiV1NotificationsNotificationResponse[], any>({
        path: `/api/v1/notifications`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description NOTIF-BELL-001: Unread count for bell badge.
     *
     * @tags notifications
     * @name GetNotificationCountApiV1NotificationsCountGet
     * @summary Get Notification Count
     * @request GET:/api/v1/notifications/count
     * @secure
     */
    getNotificationCountApiV1NotificationsCountGet: (params: RequestParams = {}) =>
      this.http.request<NotificationCountResponse, any>({
        path: `/api/v1/notifications/count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description NOTIF-DRAWER-003: Dismiss removes from drawer, decrements counter.
     *
     * @tags notifications
     * @name DismissNotificationApiV1NotificationsNotificationIdDismissPost
     * @summary Dismiss Notification
     * @request POST:/api/v1/notifications/{notification_id}/dismiss
     * @secure
     */
    dismissNotificationApiV1NotificationsNotificationIdDismissPost: (
      notificationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<any, HTTPValidationError>({
        path: `/api/v1/notifications/${notificationId}/dismiss`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description TASK-WIDGET-001 / TASK-DRAWER-001: Get pending tasks (evaluate on read). Returns endorsement tasks for teammates who have active habits and haven't been fully endorsed by the current user today.
     *
     * @tags tasks
     * @name GetTasksApiV1TasksGet
     * @summary Get Tasks
     * @request GET:/api/v1/tasks
     * @secure
     */
    getTasksApiV1TasksGet: (params: RequestParams = {}) =>
      this.http.request<TaskListResponse, any>({
        path: `/api/v1/tasks`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Simple ping endpoint for testing.
     *
     * @name PingApiV1PingGet
     * @summary Ping
     * @request GET:/api/v1/ping
     * @secure
     */
    pingApiV1PingGet: (params: RequestParams = {}) =>
      this.http.request<any, any>({
        path: `/api/v1/ping`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
